import { useCallback } from 'react';
import { BlockType } from '@uno/common-cms';
import { MetaRenderBlock } from '../tools/blocks/MetaRenderBlock';
import { moveBlock, removeBlockFromState, removeEntity, updateBlockData, updateEntity } from '../util/block';
import insertTableBlock from '../util/block/insertTableBlock';

var useInsertTableBlockCallback = function useInsertTableBlockCallback(setEditorState) {
  return useCallback(function (config) {
    return function () {
      setEditorState(function (editorState) {
        return insertTableBlock(editorState, config);
      });
    };
  }, [setEditorState]);
};

var useRemoveBlockCallback = function useRemoveBlockCallback(setEditorState) {
  return useCallback(function (blockKey) {
    setEditorState(function (editorState) {
      return removeBlockFromState(editorState, blockKey);
    });
  }, [setEditorState]);
};

var useRemoveEntityCallback = function useRemoveEntityCallback(setEditorState) {
  return useCallback(function (entityKey) {
    setEditorState(function (editorState) {
      return removeEntity(editorState, entityKey);
    });
  }, [setEditorState]);
};

var useMoveBlockUpOrDownCallback = function useMoveBlockUpOrDownCallback(setEditorState) {
  return useCallback(function (blockKey, direction) {
    setEditorState(function (editorState) {
      return moveBlock(editorState, blockKey, direction);
    });
  }, [setEditorState]);
};

var useUpdateEntityCallback = function useUpdateEntityCallback(setEditorState) {
  return useCallback(function (entityKey) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var keepExistingSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return setEditorState(function (editorState) {
      return updateEntity(editorState, entityKey, data, keepExistingSelection);
    });
  }, [setEditorState]);
};

var useUpdateBlockDataCallback = function useUpdateBlockDataCallback(setEditorState) {
  return useCallback(function (blockKey, data) {
    setEditorState(function (editorState) {
      return updateBlockData(editorState, blockKey, data);
    });
  }, [setEditorState]);
};

var useBlockRendererCallback = function useBlockRendererCallback(_ref) {
  var editor = _ref.editor,
      editorState = _ref.editorState;
  return useCallback(function (contentBlock) {
    return {
      component: MetaRenderBlock,
      editable: contentBlock.getType() !== BlockType.ATOMIC,
      props: {
        type: contentBlock.getType(),
        editor: editor,
        editorState: editorState
      }
    };
  }, [editorState, editor]);
};

export { useInsertTableBlockCallback, useRemoveBlockCallback, useRemoveEntityCallback, useMoveBlockUpOrDownCallback, useUpdateEntityCallback, useUpdateBlockDataCallback, useBlockRendererCallback };